/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />

module App.Controllers
{
    export interface IContactShortController extends IBaseController
    {

    }

    export class NoTyreChangeContactController extends BaseController implements IContactShortController
    {
        static controllerId = 'noTyreChangeContactController';
        showFormErrors: boolean = false;
        firstName: string
        lastName: string
        email: string
        telephone: string
        emailRegex = Constants.regexExp.email;
        licensePlate: string
        nextClicked: boolean = false;
        information: any

        nextStepNumber: string
        prevStepNumber: string

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            '$stateParams',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            SnackbarFactory.factoryId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId
        ];

        constructor(public $rootScope: Interfaces.IAppRootScope, $scope: any, $q: ng.IQService, $stateParams: ng.ui.IStateParamsService,
            sessionService: Interfaces.ISessionService,
            navigationService: Interfaces.INavigationService,
            compositionService: Interfaces.ICompositionService,
            snackbarFactory: Interfaces.ISnackbarFactory,
            ngDialog: any,
            $sce: any,
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService)
        {
            super($rootScope, $scope, $q, sessionService, navigationService, compositionService, ngDialog, $sce, validationService, accountService, snackbarFactory)

            this.nextStepNumber = (sessionService.maxStepNumber - 1).toString()
            this.prevStepNumber = (sessionService.maxStepNumber - 2).toString()

            compositionService.getFormInformation().then(result => this.information = result)

            var composition = this.sessionService.composition

            if (composition != null && composition.address != null)
            {
                if (composition.address.firstName != null && composition.address.firstName != '')
                    this.firstName = composition.address.firstName
                else if (Variables.firstName != '')
                    this.firstName = Variables.firstName

                if (composition.address.lastName != null && composition.address.lastName != '')
                    this.lastName = composition.address.lastName
                else if (Variables.lastName != '')
                    this.lastName = Variables.lastName

                if (composition.address.email != null && composition.address.email != '')
                    this.email = composition.address.email
                else if (Variables.email != '')
                    this.email = Variables.email

                if (composition.address.phoneNumber)
                    this.telephone = composition.address.phoneNumber
                else
                    this.telephone = Variables.telephone

                if (composition.licensePlate)
                    this.licensePlate = composition.licensePlate
                else
                    this.licensePlate = Variables.license
            } else
            {
                if (Variables.firstName != '')
                    this.firstName = Variables.firstName
                if (Variables.lastName != '')
                    this.lastName = Variables.lastName
                if (Variables.email != '')
                    this.email = Variables.email
                if (Variables.license)
                    this.licensePlate = Variables.license
                if (Variables.phone)
                    this.telephone = Variables.phone
            }

            this.scrollTop()
        }
        scrollTop = () =>
        {
            window.scrollTo(0, 0)
        }
        gotoNextStep()
        {
            this.showFormErrors = true

            if (this.$scope.noTyreChangeContactForm.$valid)
            {

                if (!this.nextClicked)
                {
                    this.nextClicked = true

                    var composition = this.sessionService.composition

                    if (composition == null)
                        composition = new App.Classes.Composition()

                    if (composition.address == null)
                        composition.address = new Classes.Address()

                    composition.address.firstName = this.firstName
                    composition.address.lastName = this.lastName
                    composition.address.email = this.email
                    composition.address.phoneNumber = this.telephone
                    composition.licensePlate = this.licensePlate
                    composition.utmParams = App.Variables.utmParams

                    this.sessionService.composition = composition

                    this.setCompositionValue(Constants.apiServiceStateCalls.license, this.licensePlate, true).then(
                        (result: Classes.IComposition) =>
                        {

                        }).catch((err) =>
                        {
                            console.log('error setCompositionValue name: ' + JSON.stringify(err))
                        }).finally(() =>
                        {
                            this.nextClicked = false
                        })
                }

            } else
            {
                this.snackbarFactory.show('Vul alle velden', 4000)
            }
        }
    }

    app.controller(NoTyreChangeContactController.controllerId, NoTyreChangeContactController)
}